export default __webpack_public_path__ + "static/2-3b6af638bc92e1e40385d0c218698a72.jpeg";